export default __webpack_public_path__ + "static/media/reactjs.78e61144.png";